module.exports = __webpack_public_path__ + "static/media/icon-checked-disabled2.61fc0c39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-checked-disabled2.svg
// module id = 640
// module chunks = 0